import {AttrsSchema, Component, jsx} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {SelectEl} from 'common/components/select';
import {SelectTheme} from 'common/components/select/constants';
import {InputEl} from 'common/components/input';
import {parseNumber} from 'common/util';

import css from './index.inline.styl';

type FlowsCardinalityControlAttrs = {
  cardinality: number;
};

export interface FlowsCardinalityControlJsxProps {
  attrs: FlowsCardinalityControlAttrs;
  on: {
    change: (ev: CustomEvent<number>) => void;
  };
}

export class FlowsCardinalityControl extends Component<EmptyObj, FlowsCardinalityControlAttrs> {
  static get attrsSchema(): AttrsSchema<FlowsCardinalityControlAttrs> {
    return {
      ...super.attrsSchema,
      cardinality: `number`,
    };
  }

  get config() {
    return {
      css,
      useShadowDom: true,
      template: () => {
        return (
          <SelectEl
            sel='.cardinality-control'
            attrs={{
              theme: SelectTheme.Secondary,
              'selected-option': `${this.attr(`cardinality`)} rows`,
              'never-show-caret': true,
            }}
          >
            <div sel='.cardinality-control-container' attrs={{slot: `body`}}>
              <h4>Rows of Events</h4>
              <h5>The number of events in each column</h5>
              <div sel='.option-container'>
                <InputEl
                  attrs={{type: `number`, size: `medium`}}
                  props={{value: this.attr(`cardinality`).toString()}}
                  on={{
                    change: (ev) => {
                      const value = parseNumber(ev.detail.value);
                      if (value !== null && value >= 1) {
                        this.dispatchEvent(new CustomEvent(`change`, {detail: parseNumber(ev.detail.value)}));
                      }
                    },
                  }}
                />
                rows of events
              </div>
            </div>
          </SelectEl>
        );
      },
    };
  }
}

export const FlowsCardinalityControlEl = defineAndMakeJsxFactory<FlowsCardinalityControlJsxProps>(
  `flows-cardinality-control`,
  FlowsCardinalityControl,
);
export const FlowsCardinalityControlReact = panel2react<FlowsCardinalityControlJsxProps>(
  `flows-cardinality-control`,
  FlowsCardinalityControl,
);
